/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TShowQuizModel,
  IShowQuizRequest,
  IMappers,
  IShowQuizResponse,
  IShowQuizResponseError,
  TShowQuizResponse,
} from './types';

const defaultConfig: TShowQuizModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'quiz',
  pathApi: '/v1/show-quiz/',
  hostType: 'api',
} as TShowQuizModel;

function createShowQuizModel(parameters: IShowQuizRequest): TShowQuizModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IShowQuizOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IShowQuizRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchShowQuiz<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IShowQuizOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TShowQuizResponse> {
  const { response, statusCode } = await httpApi.fetch(createShowQuizModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IShowQuizResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IShowQuizResponseError);
    }
  }

  return { response, statusCode } as TShowQuizResponse;
}

export { defaultConfig, createShowQuizModel, fetchShowQuiz };
